import { render, staticRenderFns } from "./KanbanTask.vue?vue&type=template&id=637f1e36&"
import script from "./KanbanTask.vue?vue&type=script&lang=js&"
export * from "./KanbanTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports